import { useDispatch, useSelector } from "react-redux";

import { useEffect, useState } from "react";
import $ from "jquery";
import Swal from "sweetalert2";
import LoaderAHSF from "../../Components/LoaderAHSF";
import InputAHSF from "../../Components/InputAHSF";
import ButtonAHSF from "../../Components/ButtonAHSF";
import { setRefreshTable } from "../../Redux/Reducers/VariousVariables";
import {
  AddOpportunitiesObtainedData,
  GetOneOpportunitiesObtained,
  restValidateOpportunitiesObtained,
  UpdateOpportunitiesObtainedData,
  ValidateOpportunitiesObtained,
} from "../../Redux/Reducers/ReportStage/OpportunitiesObtained";
import TextAreaAHSF from "../../Components/TextAreaAHSF";
import DateInput from "../../Components/DateInput";
import moment from "moment-timezone";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../Services/Account/EncryptionParams";

const AddEditOpportunitiesObtained = (props) => {
  const dispatch = useDispatch();
  let { stageGuid } = useParams();

  stageGuid = decryptToken(stageGuid);
  const state = useSelector((state) => {
    return {
      //////////////////////////////////////////////////////////

      OneOpportunitiesObtained:
        state.OpportunitiesObtained.OneOpportunitiesObtained,
      UpdateOpportunitiesObtained:
        state.OpportunitiesObtained.UpdateOpportunitiesObtained,
      OpportunitiesObtainedValidate:
        state.OpportunitiesObtained.OpportunitiesObtainedValidate,
      loadingOneOpportunitiesObtained:
        state.OpportunitiesObtained.loadingOneOpportunitiesObtained,
    };
  });

  console.log(
    state.OneOpportunitiesObtained?.entityProvidingOpportunity,
    "qasem"
  );
  // Gender options for dropdown

  // State for the project admin form

  const [OpportunitiesObtainedList, setOpportunitiesObtainedList] = useState({
    pR_OpportunitiesObtainedId:
      state.OneOpportunitiesObtained?.pR_OpportunitiesObtainedId,
    opportunityDetails: state.OneOpportunitiesObtained?.opportunityDetails,
    utilizationMechanism: state.OneOpportunitiesObtained?.utilizationMechanism,
    dateOfOpportunity: state.OneOpportunitiesObtained?.dateOfOpportunity,
    entityProvidingOpportunity:
      state.OneOpportunitiesObtained?.entityProvidingOpportunity,

    pR_ReportsStagesGuid: stageGuid,
  });
  // Effect to fetch TypeOfJobOpportunity data

  // Function to update an existing project management team member

  const AddOpportunitiesObtained = async () => {
    const validationList = await dispatch(
      ValidateOpportunitiesObtained({
        opportunityDetails: OpportunitiesObtainedList.opportunityDetails,

        utilizationMechanism: OpportunitiesObtainedList.utilizationMechanism,
        dateOfOpportunity: OpportunitiesObtainedList.dateOfOpportunity,
        entityProvidingOpportunity:
          OpportunitiesObtainedList.entityProvidingOpportunity,
      })
    );
    //console.log(validationList, validationList.payload.length, "bnbnmbnmb");
    // If no validation errors, add team member
    if (validationList.payload.length === 0) {
      await dispatch(
        AddOpportunitiesObtainedData({
          opportunityDetails: OpportunitiesObtainedList.opportunityDetails,
          utilizationMechanism: OpportunitiesObtainedList.utilizationMechanism,
          dateOfOpportunity: OpportunitiesObtainedList.dateOfOpportunity,
          entityProvidingOpportunity:
            OpportunitiesObtainedList.entityProvidingOpportunity,
          pR_ReportsStagesGuid: OpportunitiesObtainedList.pR_ReportsStagesGuid,
        })
      );
      $(".close-btn").trigger("click");
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم اضافة المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
      dispatch(setRefreshTable());
    }
  };

  const UpdateOpportunitiesObtained = async () => {
    const validationList = await dispatch(
      ValidateOpportunitiesObtained({
        opportunityDetails: OpportunitiesObtainedList.opportunityDetails,

        utilizationMechanism: OpportunitiesObtainedList.utilizationMechanism,
        dateOfOpportunity: OpportunitiesObtainedList.dateOfOpportunity,
        entityProvidingOpportunity:
          OpportunitiesObtainedList.entityProvidingOpportunity,
      })
    );
    // If no validation errors, update team member
    if (validationList.payload.length === 0) {
      await dispatch(
        UpdateOpportunitiesObtainedData({
          pR_OpportunitiesObtainedId:
            OpportunitiesObtainedList.pR_OpportunitiesObtainedId,
          opportunityDetails: OpportunitiesObtainedList.opportunityDetails,
          utilizationMechanism: OpportunitiesObtainedList.utilizationMechanism,
          dateOfOpportunity: OpportunitiesObtainedList.dateOfOpportunity,
          entityProvidingOpportunity:
            OpportunitiesObtainedList.entityProvidingOpportunity,
          pR_ReportsStagesGuid: OpportunitiesObtainedList.pR_ReportsStagesGuid,
        })
      );
      $(".close-btn").trigger("click");
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم تعديل المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
      dispatch(setRefreshTable());
    }
  };
  useEffect(() => {
    dispatch(restValidateOpportunitiesObtained());
  }, []);
  useEffect(() => {
    if (props != null) {
      dispatch(GetOneOpportunitiesObtained(props.pR_OpportunitiesObtainedId));
    }
  }, [props.pR_OpportunitiesObtainedId]);
  useEffect(() => {
    if (
      !state.loadingOneOpportunitiesObtained &&
      Object.keys(props).length != 0
    ) {
      setOpportunitiesObtainedList({
        ...state.OneOpportunitiesObtained,
      });
    } else {
      setOpportunitiesObtainedList({
        opportunityDetails: null,
        utilizationMechanism: null,
        dateOfOpportunity: null,
        entityProvidingOpportunity: null,
        pR_ReportsStagesGuid: OpportunitiesObtainedList.pR_ReportsStagesGuid,
      });
    }
  }, [state.OneOpportunitiesObtained]);

  console.log(OpportunitiesObtainedList?.entityProvidingOpportunity, "qasem2");

  //   const shouldDisableFields = !(

  //     (
  //       state.ActiveRound == state.ApplicationInformation?.aI_RoundYearId &&
  //       state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
  //       window.location.href.includes("manager") == false
  //     )
  //   );
  //to render html after loading ends
  return (
    <>
      {!state.loadingOneOpportunitiesObtained ? (
        <>
          <div className="AddEdite">
            <TextAreaAHSF
              fieldsName="opportunityDetails"
              show={true}
              disabled={props.shouldDisableFields}
              onChange={(e) => {
                setOpportunitiesObtainedList({
                  ...OpportunitiesObtainedList,
                  opportunityDetails: e.target.value,
                });
              }}
              defaultValue={OpportunitiesObtainedList?.opportunityDetails}
              showValidationMessage={
                state.OpportunitiesObtainedValidate
                  ? state.OpportunitiesObtainedValidate.includes(
                      "opportunityDetails"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <TextAreaAHSF
              fieldsName="utilizationMechanism"
              show={true}
              disabled={props.shouldDisableFields}
              onChange={(e) => {
                setOpportunitiesObtainedList({
                  ...OpportunitiesObtainedList,
                  utilizationMechanism: e.target.value,
                });
              }}
              defaultValue={OpportunitiesObtainedList?.utilizationMechanism}
              showValidationMessage={
                state.OpportunitiesObtainedValidate
                  ? state.OpportunitiesObtainedValidate.includes(
                      "utilizationMechanism"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />

            <DateInput
              fieldsName="dateOfOpportunity"
              list=""
              date={state.OneOpportunitiesObtained?.dateOfOpportunity}
              onChange={(e) => {
                setOpportunitiesObtainedList({
                  ...OpportunitiesObtainedList,
                  dateOfOpportunity: e, // التحديث هنا
                });
              }}
              disabled={props.shouldDisableFields}
              showValidationMessage={
                state.OpportunitiesObtainedValidate
                  ? state.OpportunitiesObtainedValidate.includes(
                      "dateOfOpportunity"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />

            <InputAHSF
              fieldsName="entityProvidingOpportunity"
              show={true}
              disabled={props.shouldDisableFields}
              onChange={(e) => {
                setOpportunitiesObtainedList({
                  ...OpportunitiesObtainedList,
                  entityProvidingOpportunity: e.target.value,
                });
              }}
              defaultValue={
                state.OneOpportunitiesObtained?.entityProvidingOpportunity
                // OpportunitiesObtainedList?.entityProvidingOpportunity
              }
              showValidationMessage={
                state.OpportunitiesObtainedValidate
                  ? state.OpportunitiesObtainedValidate.includes(
                      "entityProvidingOpportunity"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            {!props.shouldDisableFields ? (
            <div className="containersButton">
              <div>
                <ButtonAHSF
                  type={"submitter"}
                  onClick={() => {
                    props.canEdit == "edit"
                      ? UpdateOpportunitiesObtained()
                      : AddOpportunitiesObtained();
                  }}
                  disabled={false}
                  title={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                  text={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                  show={true}
                />
              </div>
            </div>
             ) : (
              ""
            )} 
          </div>
        </>
      ) : (
        ""
      )}
      <LoaderAHSF show={state.loadingOneOpportunitiesObtained} />
    </>
  );
};

export default AddEditOpportunitiesObtained;
